export default __webpack_public_path__ + "static/media/wave_text_4.58be91e0.png";